import React, { useState } from 'react';

import Overlay from '../../../Overlay';
import { icons } from '../../../../../helpers/icons';
import { useAppSelector, useOverflowHidden } from '../../../../../hooks/hooks';
import CourseFilterModal from '../CourseFilterModal';

const CourseFilterButton: React.FC = () => {
  const { activeFilters } = useAppSelector((state) => state.libraryReducer);
  const [isModalOpen, setIsModalOpen] = useState(false);
  useOverflowHidden(isModalOpen);

  return (
    <>
      <Overlay
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        className="max-sm:w-auto"
      >
        <CourseFilterModal onClose={() => setIsModalOpen(false)} />
      </Overlay>
      <div
        className="flex items-center gap-2 px-2 py-1 bg-white border rounded cursor-pointer border-core-dark"
        onClick={() => setIsModalOpen(true)}
      >
        <div className="font-medium text-regular text-core-dark">
          Filter by
          {activeFilters.secondaryFilter &&
            `: ${activeFilters.secondaryFilter.name}`}
        </div>
        <div className="shrink-0">
          <img src={icons.arrowDown} alt="" />
        </div>
      </div>
    </>
  );
};

export default CourseFilterButton;
